import React, { useMemo } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { DEFAULT_BREAK_TIME, DEFAULT_SPEED } from '@src/constants/voice';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import actions from '@src/redux/actions';
import { countTextLength } from '@src/services/tts';
import SaveIcon from '@mui/icons-material/Save';
import { useTranslation } from 'react-i18next';
import { updateProject } from '@src/apis/project';
import { CONVERTING_STATUS } from '@src/constants/project';

const SaveButton = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { multiBlock, title, voiceDefault, audioType } = useSelector(
    (state) => state.project,
  );
  const location = useLocation();
  const projectId = location.pathname.split('/')[2];
  const [isSaving, setIsSaving] = React.useState(false);

  const { blocks } = multiBlock || {};
  const isMultiBlockProcessing = useMemo(
    () =>
      Object.values(blocks).filter(
        (block) => block.status === CONVERTING_STATUS.IN_PROGRESS,
      ).length > 0,
    [blocks],
  );
  const saveProject = async () => {
    setIsSaving(true);
    const response = await updateProject(projectId, {
      title,
      blocks: multiBlock?.blockIds?.map((blockId) => ({
        id: blockId,
        characters: countTextLength(blocks[blockId].text || ''),
        text: blocks[blockId].text || undefined,
        voiceCode: blocks[blockId]?.voiceCode || voiceDefault?.code,
        breakTime: blocks[blockId]?.breakTime || DEFAULT_BREAK_TIME,
        speed: blocks[blockId]?.speed || DEFAULT_SPEED,
        elements: blocks[blockId]?.elements,
        isSample: blocks[blockId]?.isSample || false,
      })),
      audioType,
    });
    setIsSaving(false);
    dispatch(actions.project.saveProject());
    dispatch(
      actions.noti.push({
        severity: 'success',
        message: t('saveProjectSuccessful'),
      }),
    );
    return response;
  };

  const hasOneBlockEmpty =
    Object.values(blocks).length === 1 &&
    Object.values(blocks).filter((block) => !block.text);

  const isDisabledBtnSave = hasOneBlockEmpty || isMultiBlockProcessing;

  return (
    <Button
      startIcon={
        isSaving ? (
          <CircularProgress
            value={75}
            className="circular-progress"
            size="24px"
          />
        ) : (
          <SaveIcon style={{ fontSize: '24px' }} />
        )
      }
      className="save-btn"
      variant="outlined"
      disabled={isDisabledBtnSave}
      onClick={saveProject}
    >
      {t('saveName')}
    </Button>
  );
};

export default SaveButton;
